import { useTranslation } from "react-i18next";
import { daysOfWeek, mealTimes } from "../components/MenuPlan/utils";

const useMenuPlanTableData = (menuPlan, recipes) => {
  const { t } = useTranslation();

  const tableHeaders = ["", ...daysOfWeek.map((day) => t(`tableHeaders.daysOfWeek.${day}`))];

  const tableRows = [];
  mealTimes.forEach((meal) => {
    const row = [t(`tableHeaders.mealTimes.${meal}`)];
    daysOfWeek.forEach((day) => {
      const recipesForDayMeal = menuPlan
        .filter((item) => item.day === day && item.meal === meal)
        .map((item) => {
          const recipe = recipes.find((r) => r.id === item.recipeId);
          return recipe ? recipe.title : t("recipeNotFound");
        })
        .join(", ");
      row.push(recipesForDayMeal);
    });
    tableRows.push(row);
  });

  return { tableHeaders, tableRows };
};

export default useMenuPlanTableData;
